(() => {
  'use strict';

  /* PN8A_LIVE_EVENTS */

  const root =
    document.querySelector(
      '[data-pne-page]'
    );

  if (!root) return;


  const grid =
    root.querySelector(
      '[data-pne-grid]'
    );

  const count =
    root.querySelector(
      '[data-pne-count]'
    );

  if (!grid) return;


  const search =
    root.querySelector(
      '[data-pne-search]'
    );

  const category =
    root.querySelector(
      '[data-pne-category]'
    );

  const mode =
    root.querySelector(
      '[data-pne-mode]'
    );

  const location =
    root.querySelector(
      '[data-pne-location]'
    );

  const college =
    root.querySelector(
      '[data-pne-college]'
    );

  const dateFilter =
    root.querySelector(
      '[data-pne-date]'
    );

  const sort =
    root.querySelector(
      '[data-pne-sort]'
    );

  const reset =
    root.querySelector(
      '[data-pne-reset]'
    );


  let events = [];


  function escapeHTML(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }


  function normal(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[_-]+/g, ' ');
  }


  function isAll(value) {

    const clean =
      normal(value);

    return (
      !clean ||
      clean === 'all' ||
      clean.startsWith('all ')
    );

  }


  function money(
    value,
    currency = 'INR'
  ) {

    const amount =
      Number(value || 0);


    if (!amount) {
      return 'Free';
    }


    try {

      return new Intl.NumberFormat(
        'en-IN',
        {
          style:'currency',
          currency:
            currency || 'INR',
          maximumFractionDigits:0
        }
      ).format(amount);

    }
    catch (_) {

      return `₹${amount}`;

    }

  }


  function dateParts(row) {

    const start =
      new Date(
        row.starts_at
      );

    const end =
      new Date(
        row.ends_at
      );


    if (
      Number.isNaN(
        start.getTime()
      )
    ) {

      return {
        date:'Date TBA',
        time:'Time TBA'
      };

    }


    const date =
      start.toLocaleDateString(
        'en-IN',
        {
          weekday:'short',
          day:'numeric',
          month:'short',
          year:'numeric'
        }
      );


    const startTime =
      start.toLocaleTimeString(
        'en-IN',
        {
          hour:'numeric',
          minute:'2-digit'
        }
      );


    const endTime =
      Number.isNaN(
        end.getTime()
      )
        ? ''
        : end.toLocaleTimeString(
            'en-IN',
            {
              hour:'numeric',
              minute:'2-digit'
            }
          );


    return {
      date,
      time:
        endTime
          ? `${startTime} – ${endTime}`
          : startTime
    };

  }


  function locationText(row) {

    if (
      row.mode === 'online'
    ) {
      return 'Online';
    }


    if (
      row.mode === 'hybrid'
    ) {

      return row.venue
        ? `Hybrid · ${row.venue}`
        : 'Hybrid';

    }


    return (
      row.venue ||
      'Venue TBA'
    );

  }


  function registrationLabel(row) {

    const status =
      row.my_registration_status;


    if (
      status === 'confirmed' ||
      status === 'reserved' ||
      status === 'payment_pending'
    ) {
      return 'Registered ✓';
    }


    if (
      status === 'attended'
    ) {
      return 'Attended ✓';
    }


    return null;

  }


  function registrationClosed(row) {

    const now =
      Date.now();


    const start =
      new Date(
        row.starts_at
      ).getTime();


    const deadline =
      row.registration_deadline
        ? new Date(
            row.registration_deadline
          ).getTime()
        : null;


    return (
      (
        Number.isFinite(start) &&
        start <= now
      )
      ||
      (
        deadline &&
        deadline <= now
      )
    );

  }


  function card(row) {

    const timing =
      dateParts(row);


    const registered =
      registrationLabel(row);


    const full =
      row.capacity !== null &&
      row.spots_left !== null &&
      Number(row.spots_left) <= 0;


    const closed =
      registrationClosed(row);


    let action = '';


    if (
      row.my_registration_status ===
      'attended'
    ) {

      action = `
        <button
          type="button"
          class="pn8e-btn pn8e-btn--quiet"
          disabled
        >
          Attended ✓
        </button>
      `;

    }
    else if (registered) {

      action = `
        <button
          type="button"
          class="pn8e-btn pn8e-btn--registered"
          data-pn8e-cancel="${escapeHTML(row.id)}"
        >
          ${escapeHTML(registered)}
        </button>
      `;

    }
    else if (row.is_paid) {

      action = `
        <button
          type="button"
          class="pn8e-btn"
          disabled
          title="Paid event checkout is added in the Payment Pass"
        >
          ${escapeHTML(
            money(
              row.price,
              row.currency
            )
          )}
          · Checkout soon
        </button>
      `;

    }
    else if (closed) {

      action = `
        <button
          type="button"
          class="pn8e-btn"
          disabled
        >
          Registration closed
        </button>
      `;

    }
    else if (full) {

      action = `
        <button
          type="button"
          class="pn8e-btn"
          disabled
        >
          Event full
        </button>
      `;

    }
    else {

      action = `
        <button
          type="button"
          class="pn8e-btn"
          data-pn8e-register="${escapeHTML(row.id)}"
        >
          Register free →
        </button>
      `;

    }


    const capacity =
      row.capacity === null
        ? ''
        : `
          <span>
            ${
              Number(
                row.spots_left
              ) > 0
                ? `${Number(
                    row.spots_left
                  )} spots left`
                : 'Full'
            }
          </span>
        `;


    const image =
      row.cover_image_url
        ? `
          <img
            src="${escapeHTML(row.cover_image_url)}"
            alt=""
            loading="lazy"
          >
        `
        : `
          <div class="pn8e-placeholder">
            <span>✦</span>
            <small>PEERNEST EVENT</small>
          </div>
        `;


    return `
      <article
        class="pne-card pn8e-card"
        data-pn8e-event="${escapeHTML(row.id)}"
      >

        <div class="pn8e-media">
          ${image}

          <span class="pn8e-type">
            ${escapeHTML(
              normal(
                row.event_type
              )
            )}
          </span>

          <button
            type="button"
            class="pn8e-save ${row.is_saved ? 'is-saved' : ''}"
            data-pn8e-save="${escapeHTML(row.id)}"
            data-saved="${row.is_saved ? 'true' : 'false'}"
            aria-label="${row.is_saved ? 'Unsave event' : 'Save event'}"
          >
            ${row.is_saved ? '♥' : '♡'}
          </button>
        </div>


        <div class="pn8e-body">

          <div class="pn8e-meta">
            <span>
              ${escapeHTML(timing.date)}
            </span>

            <span>
              ${escapeHTML(timing.time)}
            </span>
          </div>


          <h3>
            ${escapeHTML(row.title)}
          </h3>


          ${
            row.description
              ? `
                <p>
                  ${escapeHTML(row.description)}
                </p>
              `
              : ''
          }


          <div class="pn8e-facts">

            <span>
              ${escapeHTML(
                locationText(row)
              )}
            </span>

            <span>
              ${escapeHTML(
                money(
                  row.price,
                  row.currency
                )
              )}
            </span>

            ${capacity}

          </div>


          <div class="pn8e-actions">

            ${action}

          </div>

        </div>

      </article>
    `;

  }


  function matchesDate(
    row,
    value
  ) {

    if (isAll(value)) {
      return true;
    }


    const filter =
      normal(value);


    const date =
      new Date(
        row.starts_at
      );


    if (
      Number.isNaN(
        date.getTime()
      )
    ) {
      return false;
    }


    const now =
      new Date();


    if (
      filter.includes('upcoming')
    ) {
      return date >= now;
    }


    if (
      filter.includes('today')
    ) {

      return (
        date.toDateString() ===
        now.toDateString()
      );

    }


    if (
      filter.includes('week')
    ) {

      const limit =
        new Date(
          now.getTime() +
          7 * 24 * 60 * 60 * 1000
        );


      return (
        date >= now &&
        date <= limit
      );

    }


    if (
      filter.includes('month')
    ) {

      return (
        date.getMonth() ===
          now.getMonth()
        &&
        date.getFullYear() ===
          now.getFullYear()
      );

    }


    return true;

  }


  function visibleRows() {

    const query =
      normal(
        search?.value
      );


    const categoryValue =
      category?.value || 'all';


    const modeValue =
      mode?.value || 'all';


    const locationValue =
      location?.value || 'all';


    const dateValue =
      dateFilter?.value || 'all';


    let rows =
      events.filter(
        row => {

          const haystack =
            normal(
              [
                row.title,
                row.description,
                row.event_type,
                row.mode,
                row.venue
              ]
                .filter(Boolean)
                .join(' ')
            );


          const searchOkay =
            !query ||
            haystack.includes(
              query
            );


          const categoryOkay =
            isAll(categoryValue)
            ||
            normal(
              row.event_type
            ) ===
            normal(
              categoryValue
            )
            ||
            normal(
              row.event_type
            ).includes(
              normal(
                categoryValue
              )
            );


          const modeOkay =
            isAll(modeValue)
            ||
            normal(
              row.mode
            ) ===
            normal(
              modeValue
            );


          const locationOkay =
            isAll(locationValue)
            ||
            normal(
              locationText(row)
            ).includes(
              normal(
                locationValue
              )
            );


          return (
            searchOkay &&
            categoryOkay &&
            modeOkay &&
            locationOkay &&
            matchesDate(
              row,
              dateValue
            )
          );

        }
      );


    const sortValue =
      normal(
        sort?.value
      );


    if (
      sortValue.includes('latest')
      ||
      sortValue.includes('newest')
    ) {

      rows.sort(
        (a,b) =>
          new Date(b.starts_at) -
          new Date(a.starts_at)
      );

    }
    else if (
      sortValue.includes('popular')
    ) {

      rows.sort(
        (a,b) =>
          Number(
            b.registration_count || 0
          )
          -
          Number(
            a.registration_count || 0
          )
      );

    }
    else if (
      sortValue.includes('price')
    ) {

      rows.sort(
        (a,b) =>
          Number(a.price || 0)
          -
          Number(b.price || 0)
      );

    }
    else {

      rows.sort(
        (a,b) =>
          new Date(a.starts_at) -
          new Date(b.starts_at)
      );

    }


    return rows;

  }


  function render() {

    const rows =
      visibleRows();


    if (count) {

      count.textContent =
        String(
          rows.length
        );

    }


    if (!rows.length) {

      grid.innerHTML = `
        <div class="pn8e-empty">
          <span>◇</span>

          <strong>
            No events match this view yet.
          </strong>

          <p>
            Try another filter or check back when new PeerNest events are published.
          </p>
        </div>
      `;

      return;

    }


    grid.innerHTML =
      rows
        .map(card)
        .join('');

  }


  async function rpc(
    name,
    body = {}
  ) {

    return window.PeerNestDB
      .request(
        `rpc/${name}`,
        '',
        {
          method:'POST',
          body
        }
      );

  }


  async function hasSession() {

    try {

      const session =
        await window.PeerNestDB
          .getSession();


      return !!session?.access_token;

    }
    catch (_) {

      return false;

    }

  }


  async function requireSession() {

    if (
      await hasSession()
    ) {
      return true;
    }


    window.location.href =
      '/pages/login';


    return false;

  }


  async function load() {

    grid.innerHTML = `
      <div class="pn8e-empty">
        <span>◌</span>
        <strong>Loading live events…</strong>
      </div>
    `;


    try {

      const result =
        await rpc(
          'pn8a_list_public_events',
          {
            p_limit:100,
            p_offset:0
          }
        );


      events =
        Array.isArray(result)
          ? result
          : [];


      render();


      const requestedRow =
        findRequestedEvent();


      if (requestedRow) {

        openEventModal(
          requestedRow
        );

      }


    }
    catch (error) {

      console.error(
        '[PeerNest 8A Events]',
        error
      );


      grid.innerHTML = `
        <div class="pn8e-empty">
          <span>!</span>

          <strong>
            Events could not be loaded.
          </strong>

          <p>
            ${escapeHTML(
              error?.message ||
              'Please try again.'
            )}
          </p>
        </div>
      `;

    }

  }


  function bindFilters() {

    [
      search,
      category,
      mode,
      location,
      dateFilter,
      sort
    ]
      .filter(Boolean)
      .forEach(
        control => {

          control.addEventListener(
            control === search
              ? 'input'
              : 'change',
            render
          );

        }
      );


    if (reset) {

      reset.addEventListener(
        'click',
        () => {

          if (search) {
            search.value = '';
          }


          [
            category,
            mode,
            location,
            dateFilter,
            sort
          ]
            .filter(Boolean)
            .forEach(
              control => {

                control.selectedIndex =
                  0;

              }
            );


          render();

        }
      );

    }


    /*
     * Existing event schema does not yet have a
     * college relation. Do not fake college filtering.
     * Admin tagging is added later in 8A.
     */

    if (college) {

      college.disabled =
        true;


      college.title =
        'College event tagging will be enabled in the Admin 8A pass.';

    }

  }


  root.addEventListener(
    'click',
    async event => {

      const register =
        event.target.closest(
          '[data-pn8e-register]'
        );


      if (register) {

        if (
          !await requireSession()
        ) {
          return;
        }


        register.disabled =
          true;

        register.textContent =
          'Registering…';


        try {

          await rpc(
            'pn8a_register_free_event',
            {
              p_event_id:
                register.dataset
                  .pn8eRegister
            }
          );


          await load();

        }
        catch (error) {

          window.alert(
            error?.message ||
            'Could not register.'
          );


          register.disabled =
            false;

        }


        return;

      }


      const cancel =
        event.target.closest(
          '[data-pn8e-cancel]'
        );


      if (cancel) {

        cancel.disabled =
          true;

        cancel.textContent =
          'Cancelling…';


        try {

          await rpc(
            'pn8a_cancel_event_registration',
            {
              p_event_id:
                cancel.dataset
                  .pn8eCancel
            }
          );


          await load();

        }
        catch (error) {

          window.alert(
            error?.message ||
            'Could not cancel registration.'
          );


          cancel.disabled =
            false;

        }


        return;

      }


      const save =
        event.target.closest(
          '[data-pn8e-save]'
        );


      if (save) {

        if (
          !await requireSession()
        ) {
          return;
        }


        const next =
          save.dataset.saved !==
          'true';


        save.disabled =
          true;


        try {

          await rpc(
            'pn8a_save_my_event',
            {
              p_event_id:
                save.dataset
                  .pn8eSave,

              p_saved:
                next
            }
          );


          await load();

        }
        catch (error) {

          window.alert(
            error?.message ||
            'Could not update saved event.'
          );


          save.disabled =
            false;

        }

      }

    }
  );






  /* =========================================================
     PN_EVENT_DETAIL_SHEET_V2
     Large Unstop-style PeerNest event detail experience
  ========================================================= */

  function closeEventModal() {

    root
      .querySelector(
        '[data-pn8e-event-modal]'
      )
      ?.remove();


    document.body
      .classList
      .remove(
        'pn8e-modal-open'
      );


    const url =
      new URL(
        window.location.href
      );


    if (
      url.searchParams.has(
        'event'
      )
    ) {

      url.searchParams.delete(
        'event'
      );


      history.replaceState(
        null,
        '',
        url.pathname
        +
        (
          url.search ||
          ''
        )
        +
        (
          url.hash ||
          ''
        )
      );

    }

  }


  function listValue(
    value
  ) {

    if (
      value === null ||
      value === undefined ||
      value === ''
    ) {
      return [];
    }


    if (Array.isArray(value)) {
      return value;
    }


    if (
      typeof value ===
      'object'
    ) {

      return Object.values(
        value
      );

    }


    const raw =
      String(
        value
      )
        .trim();


    if (!raw) {
      return [];
    }


    try {

      const parsed =
        JSON.parse(
          raw
        );


      if (Array.isArray(parsed)) {
        return parsed;
      }


      if (
        parsed &&
        typeof parsed ===
        'object'
      ) {

        return Object.values(
          parsed
        );

      }

    }
    catch (_) {}


    return raw
      .split(
        /\n|•|\|/
      )
      .map(
        item =>
          item.trim()
      )
      .filter(Boolean);

  }


  function richListHTML(
    value,
    emptyText
  ) {

    const items =
      listValue(
        value
      );


    if (!items.length) {

      return `
        <div class="pn8e-sheet__empty-copy">
          ${escapeHTML(
            emptyText
          )}
        </div>
      `;

    }


    return `
      <div class="pn8e-sheet__list">

        ${items
          .map(
            (
              item,
              index
            ) => {

              if (
                item &&
                typeof item ===
                'object'
              ) {

                const title =
                  item.title ||
                  item.name ||
                  item.label ||
                  `Item ${index + 1}`;


                const reward =
                  item.reward ||
                  item.amount ||
                  item.value ||
                  '';


                const description =
                  item.description ||
                  item.details ||
                  item.note ||
                  '';


                return `
                  <article class="pn8e-sheet__list-item">

                    <div class="pn8e-sheet__list-number">
                      ${String(index + 1).padStart(2,'0')}
                    </div>

                    <div>

                      <h4>
                        ${escapeHTML(
                          title
                        )}
                      </h4>

                      ${
                        reward
                          ? `
                              <strong>
                                ${escapeHTML(
                                  reward
                                )}
                              </strong>
                            `
                          : ''
                      }

                      ${
                        description
                          ? `
                              <p>
                                ${escapeHTML(
                                  description
                                )}
                              </p>
                            `
                          : ''
                      }

                    </div>

                  </article>
                `;

              }


              return `
                <article class="pn8e-sheet__list-item">

                  <div class="pn8e-sheet__list-number">
                    ${String(index + 1).padStart(2,'0')}
                  </div>

                  <div>
                    <p>
                      ${escapeHTML(
                        item
                      )}
                    </p>
                  </div>

                </article>
              `;

            }
          )
          .join('')}

      </div>
    `;

  }


  function eventActionMarkup(
    row
  ) {

    const holder =
      document.createElement(
        'div'
      );


    holder.innerHTML =
      card(
        row
      );


    return (
      holder
        .querySelector(
          '.pn8e-actions'
        )
        ?.innerHTML
      ||
      ''
    );

  }


  function openEventModal(
    row
  ) {

    if (!row) {
      return;
    }


    closeEventModal();


    const eventDate =
      new Date(
        row.starts_at
      );


    const endDate =
      row.ends_at
        ? new Date(
            row.ends_at
          )
        : null;


    const deadlineDate =
      row.registration_deadline
        ? new Date(
            row.registration_deadline
          )
        : null;


    const date =
      Number.isNaN(
        eventDate.getTime()
      )
        ? 'Date TBA'
        : eventDate.toLocaleDateString(
            'en-IN',
            {
              day:'numeric',
              month:'short',
              year:'numeric'
            }
          );


    const time =
      Number.isNaN(
        eventDate.getTime()
      )
        ? 'Time TBA'
        : eventDate.toLocaleTimeString(
            'en-IN',
            {
              hour:'numeric',
              minute:'2-digit'
            }
          );


    const endTime =
      endDate &&
      !Number.isNaN(
        endDate.getTime()
      )
        ? endDate.toLocaleTimeString(
            'en-IN',
            {
              hour:'numeric',
              minute:'2-digit'
            }
          )
        : '';


    const deadline =
      deadlineDate &&
      !Number.isNaN(
        deadlineDate.getTime()
      )
        ? deadlineDate.toLocaleDateString(
            'en-IN',
            {
              day:'numeric',
              month:'short',
              year:'numeric'
            }
          )
        : 'To be announced';


    const organizer =
      row.organizer_name ||
      row.organiser_name ||
      'PeerNest';


    const teamMin =
      Number(
        row.team_size_min ||
        1
      );


    const teamMax =
      Number(
        row.team_size_max ||
        teamMin
      );


    const teamText =
      teamMin === teamMax
        ? (
            teamMin === 1
              ? 'Individual'
              : `${teamMin} members`
          )
        : `${teamMin} – ${teamMax} members`;


    const spots =
      row.spots_left ===
        null
      ||
      row.spots_left ===
        undefined
        ? 'Capacity not specified'
        : (
            Number(
              row.spots_left
            ) > 0
              ? `${Number(
                  row.spots_left
                )} spots left`
              : 'Registrations full'
          );


    const hero =
      row.cover_image_url
        ? `
            <img
              src="${escapeHTML(
                row.cover_image_url
              )}"
              alt="${escapeHTML(
                row.title ||
                'PeerNest Event'
              )}"
            >
          `
        : `
            <div class="pn8e-sheet__hero-placeholder">

              <div>
                <span>✦</span>

                <small>
                  PEERNEST EVENT
                </small>
              </div>

            </div>
          `;


    const action =
      row.participation_type === 'team'
        ? `
            <div
              class="pn8e-team-panel"
              data-pn8e-team-panel="${escapeHTML(
                row.id
              )}"
            >
              <div class="pn8e-team-loading">
                Loading team registration…
              </div>
            </div>
          `
        : eventActionMarkup(
            row
          );


    const modal =
      document.createElement(
        'div'
      );


    modal.className =
      'pn8e-sheet';

    modal.setAttribute(
      'data-pn8e-event-modal',
      ''
    );


    modal.innerHTML = `

      <button
        class="pn8e-sheet__backdrop"
        type="button"
        data-pn8e-modal-close
        aria-label="Close event"
      ></button>


      <article
        class="pn8e-sheet__panel"
        role="dialog"
        aria-modal="true"
      >

        <button
          type="button"
          class="pn8e-sheet__close"
          data-pn8e-modal-close
          aria-label="Close"
        >
          ×
        </button>


        <header class="pn8e-sheet__hero">

          ${hero}

          <div class="pn8e-sheet__hero-overlay"></div>


          <div class="pn8e-sheet__hero-content">

            <div class="pn8e-sheet__chips">

              <span>
                ${escapeHTML(
                  row.event_type ||
                  'Event'
                )}
              </span>

              <span>
                ${escapeHTML(
                  row.mode ||
                  'Mode TBA'
                )}
              </span>

            </div>


            <div>

              <small>
                HOSTED BY
                ${escapeHTML(
                  organizer
                )}
              </small>

              <h1>
                ${escapeHTML(
                  row.title ||
                  'PeerNest Event'
                )}
              </h1>

            </div>

          </div>

        </header>


        <div class="pn8e-sheet__body">

          <main class="pn8e-sheet__main">


            <section class="pn8e-sheet__section">

              <div class="pn8e-sheet__section-title">

                <span>
                  OVERVIEW
                </span>

                <h2>
                  About this event
                </h2>

              </div>


              <p class="pn8e-sheet__description">

                ${escapeHTML(
                  row.description ||
                  'Complete event details will be announced soon.'
                )}

              </p>


              <div class="pn8e-sheet__fact-grid">

                <div>
                  <small>DATE</small>
                  <strong>
                    ${escapeHTML(date)}
                  </strong>
                </div>

                <div>
                  <small>TIME</small>
                  <strong>
                    ${escapeHTML(
                      endTime
                        ? `${time} – ${endTime}`
                        : time
                    )}
                  </strong>
                </div>

                <div>
                  <small>MODE</small>
                  <strong>
                    ${escapeHTML(
                      row.mode ||
                      'TBA'
                    )}
                  </strong>
                </div>

                <div>
                  <small>VENUE</small>
                  <strong>
                    ${escapeHTML(
                      locationText(
                        row
                      )
                    )}
                  </strong>
                </div>

                <div>
                  <small>TEAM SIZE</small>
                  <strong>
                    ${escapeHTML(
                      teamText
                    )}
                  </strong>
                </div>

                <div>
                  <small>REGISTRATION DEADLINE</small>
                  <strong>
                    ${escapeHTML(
                      deadline
                    )}
                  </strong>
                </div>

              </div>

            </section>



            <section class="pn8e-sheet__section">

              <div class="pn8e-sheet__section-title">

                <span>
                  REWARDS
                </span>

                <h2>
                  Incentives & rewards
                </h2>

              </div>


              ${richListHTML(
                row.incentives ||
                row.rewards ||
                row.prizes,
                'Incentives and rewards will be announced by the organiser.'
              )}

            </section>



            <section class="pn8e-sheet__section">

              <div class="pn8e-sheet__section-title">

                <span>
                  WHO CAN JOIN
                </span>

                <h2>
                  Eligibility
                </h2>

              </div>


              <div class="pn8e-sheet__copy-card">

                ${escapeHTML(
                  row.eligibility ||
                  'Eligibility details will be announced soon.'
                )}

              </div>

            </section>



            <section class="pn8e-sheet__section">

              <div class="pn8e-sheet__section-title">

                <span>
                  EVENT FLOW
                </span>

                <h2>
                  Stages & timeline
                </h2>

              </div>


              ${richListHTML(
                row.stages ||
                row.timeline,
                'The organiser has not added event stages yet.'
              )}

            </section>



            <section class="pn8e-sheet__section">

              <div class="pn8e-sheet__section-title">

                <span>
                  IMPORTANT
                </span>

                <h2>
                  Rules & guidelines
                </h2>

              </div>


              ${richListHTML(
                row.rules ||
                row.guidelines,
                'Rules and participation guidelines will be announced soon.'
              )}

            </section>



            <section class="pn8e-sheet__section">

              <div class="pn8e-sheet__section-title">

                <span>
                  ORGANISER
                </span>

                <h2>
                  Contact & support
                </h2>

              </div>


              <div class="pn8e-sheet__organiser">

                <div class="pn8e-sheet__organiser-logo">
                  PN
                </div>

                <div>

                  <strong>
                    ${escapeHTML(
                      organizer
                    )}
                  </strong>

                  ${
                    row.contact_details ||
                    row.contact_email
                      ? `
                          <p>
                            ${escapeHTML(
                              row.contact_details ||
                              row.contact_email
                            )}
                          </p>
                        `
                      : `
                          <p>
                            Contact details will be shared by the organiser.
                          </p>
                        `
                  }

                </div>

              </div>

            </section>


          </main>



          <aside class="pn8e-sheet__side">

            <div class="pn8e-sheet__register-card">


              <div class="pn8e-sheet__price">

                <small>
                  REGISTRATION FEE
                </small>

                <strong>
                  ${escapeHTML(
                    money(
                      row.price,
                      row.currency
                    )
                  )}
                </strong>

              </div>


              <div class="pn8e-sheet__side-line">

                <span>
                  Registration closes
                </span>

                <strong>
                  ${escapeHTML(
                    deadline
                  )}
                </strong>

              </div>


              <div class="pn8e-sheet__side-line">

                <span>
                  Availability
                </span>

                <strong>
                  ${escapeHTML(
                    spots
                  )}
                </strong>

              </div>


              <div class="pn8e-sheet__side-line">

                <span>
                  Participation
                </span>

                <strong>
                  ${escapeHTML(
                    teamText
                  )}
                </strong>

              </div>


              ${
                action
                  ? `
                      <div class="pn8e-sheet__cta pn8e-actions">
                        ${action}
                      </div>
                    `
                  : ''
              }


              <small class="pn8e-sheet__secure">
                Secure registration through PeerNest
              </small>

            </div>

          </aside>

        </div>

      </article>
    `;


    root.appendChild(
      modal
    );


    document.body
      .classList
      .add(
        'pn8e-modal-open'
      );


    if (
      row.participation_type ===
      'team'
    ) {

      hydrateEventTeamPanel(
        row,
        modal
      );

    }

  }


  root.addEventListener(
    'click',
    event => {

      if (
        event.target.closest(
          '[data-pn8e-modal-close]'
        )
      ) {

        closeEventModal();

      }

    }
  );


  document.addEventListener(
    'keydown',
    event => {

      if (
        event.key ===
        'Escape'
      ) {

        closeEventModal();

      }

    }
  );




  /* =========================================================
     PN_EVENT_FINAL_FLOW_V1
     Individual paid checkout + team creation/invites/payment
  ========================================================= */


  function pnEventById(
    id
  ) {

    return events.find(
      row =>
        String(row.id) ===
        String(id)
    );

  }


  async function pnEventPaymentFunction(
    functionName,
    body
  ) {

    const session =
      await window.PeerNestDB
        .getSession();


    if (!session?.access_token) {

      throw new Error(
        'Your session expired. Please sign in again.'
      );

    }


    const response =
      await fetch(
        `https://tnlkoibetblgiovgkufs.supabase.co/functions/v1/${functionName}`,
        {
          method:'POST',

          headers:{
            Authorization:
              `Bearer ${session.access_token}`,

            'Content-Type':
              'application/json'
          },

          body:
            JSON.stringify(
              body
            )
        }
      );


    const payload =
      await response
        .json()
        .catch(
          () => ({})
        );


    if (!response.ok) {

      throw new Error(
        payload?.error
        ||
        `Payment service failed (${response.status}).`
      );

    }


    return payload;

  }


  async function pnEnsureRazorpay() {

    if (window.Razorpay) {
      return;
    }


    await new Promise(
      (
        resolve,
        reject
      ) => {

        const source =
          'https://checkout.razorpay.com/v1/checkout.js';


        const existing =
          document.querySelector(
            `script[src="${source}"]`
          );


        if (existing) {

          if (window.Razorpay) {
            resolve();
            return;
          }


          existing.addEventListener(
            'load',
            resolve,
            {
              once:true
            }
          );


          existing.addEventListener(
            'error',
            () =>
              reject(
                new Error(
                  'Razorpay checkout could not be loaded.'
                )
              ),
            {
              once:true
            }
          );


          return;

        }


        const script =
          document.createElement(
            'script'
          );


        script.src =
          source;

        script.async =
          true;


        script.onload =
          resolve;


        script.onerror =
          () =>
            reject(
              new Error(
                'Razorpay checkout could not be loaded.'
              )
            );


        document.head.appendChild(
          script
        );

      }
    );


    if (!window.Razorpay) {

      throw new Error(
        'Razorpay checkout is unavailable.'
      );

    }

  }


  async function pnRunEventRazorpay(
    reservation,
    row,
    button
  ) {

    if (
      !reservation?.payment_id
    ) {

      throw new Error(
        'Payment reservation could not be created.'
      );

    }


    const order =
      await pnEventPaymentFunction(
        'razorpay-create-order',
        {
          payment_id:
            reservation.payment_id
        }
      );


    if (
      !order?.razorpay_key_id
      ||
      !order?.razorpay_order_id
      ||
      !order?.amount
      ||
      !order?.currency
    ) {

      throw new Error(
        'Razorpay checkout could not be prepared.'
      );

    }


    await pnEnsureRazorpay();


    if (button) {
      button.textContent =
        'Complete Payment';
    }


    return await new Promise(
      (
        resolve,
        reject
      ) => {

        let settled =
          false;

        let verificationStarted =
          false;


        const checkout =
          new window.Razorpay({

            key:
              order.razorpay_key_id,

            amount:
              order.amount,

            currency:
              order.currency,

            name:
              'PeerNest',

            description:
              row.participation_type ===
                'team'
                  ? `${row.title} · Team Registration`
                  : `${row.title} · Event Registration`,

            order_id:
              order.razorpay_order_id,


            handler:
              async response => {

                if (settled) {
                  return;
                }


                verificationStarted =
                  true;


                try {

                  if (button) {

                    button.textContent =
                      'Verifying payment…';

                  }


                  const verified =
                    await pnEventPaymentFunction(
                      'razorpay-verify-payment',
                      {
                        payment_id:
                          reservation.payment_id,

                        razorpay_order_id:
                          response
                            .razorpay_order_id,

                        razorpay_payment_id:
                          response
                            .razorpay_payment_id,

                        razorpay_signature:
                          response
                            .razorpay_signature
                      }
                    );


                  if (
                    verified?.requires_refund ===
                    true
                  ) {

                    throw new Error(
                      'Payment was received but the registration could not be fulfilled. It has been flagged for refund.'
                    );

                  }


                  settled =
                    true;

                  resolve(
                    verified
                  );

                }
                catch (error) {

                  settled =
                    true;

                  reject(
                    error
                  );

                }

              },


            modal:{

              ondismiss:
                () => {

                  if (
                    settled
                    ||
                    verificationStarted
                  ) {
                    return;
                  }


                  settled =
                    true;


                  reject(
                    new Error(
                      'Payment was not completed. You can retry.'
                    )
                  );

                }

            }

          });


        checkout.on(
          'payment.failed',
          response => {

            if (
              settled
              ||
              verificationStarted
            ) {
              return;
            }


            settled =
              true;


            reject(
              new Error(
                response?.error
                  ?.description
                ||
                'Payment failed.'
              )
            );

          }
        );


        checkout.open();

      }
    );

  }


  async function pnRefreshEventModal(
    row
  ) {

    await load();


    const fresh =
      pnEventById(
        row.id
      );


    closeEventModal();


    if (fresh) {

      openEventModal(
        fresh
      );

    }

  }


  async function pnStartIndividualEventCheckout(
    row,
    button
  ) {

    const original =
      button?.textContent ||
      'Register';


    try {

      if (button) {

        button.disabled =
          true;

        button.textContent =
          'Preparing payment…';

      }


      const reservation =
        await rpc(
          'pn_pay_reserve_event',
          {
            p_event_id:
              row.id
          }
        );


      await pnRunEventRazorpay(
        reservation,
        row,
        button
      );


      await pnRefreshEventModal(
        row
      );

    }
    catch (error) {

      window.alert(
        error?.message ||
        'Could not complete event registration.'
      );

    }
    finally {

      if (
        button
        &&
        button.isConnected
      ) {

        button.disabled =
          false;

        button.textContent =
          original;

      }

    }

  }


  function pnTeamMembersHTML(
    state
  ) {

    const members =
      Array.isArray(
        state?.members
      )
        ? state.members
        : [];


    if (!members.length) {

      return `
        <div class="pn8e-team-empty">
          No team members yet.
        </div>
      `;

    }


    return members
      .map(
        member => {

          const canRemove =
            state.is_captain
            &&
            member.role !==
              'captain'
            &&
            state.team_status !==
              'registered'
            &&
            state.team_status !==
              'payment_pending'
            &&
            member.status !==
              'removed';


          return `
            <div class="pn8e-team-member">

              <div>

                <strong>
                  ${escapeHTML(
                    member.email ||
                    'Team member'
                  )}
                </strong>

                <span>
                  ${escapeHTML(
                    member.role
                  )}
                  ·
                  ${escapeHTML(
                    member.status
                  )}
                </span>

              </div>


              ${
                canRemove
                  ? `
                      <button
                        type="button"
                        data-pn8e-team-remove="${escapeHTML(
                          member.id
                        )}"
                        data-team-id="${escapeHTML(
                          state.team_id
                        )}"
                      >
                        Remove
                      </button>
                    `
                  : ''
              }

            </div>
          `;

        }
      )
      .join('');

  }


  async function hydrateEventTeamPanel(
    row,
    modal
  ) {

    const panel =
      modal?.querySelector(
        '[data-pn8e-team-panel]'
      );


    if (!panel) {
      return;
    }


    panel.innerHTML = `
      <div class="pn8e-team-loading">
        Loading team…
      </div>
    `;


    if (
      !await hasSession()
    ) {

      panel.innerHTML = `

        <div class="pn8e-team-card">

          <span class="pn8e-team-kicker">
            TEAM REGISTRATION
          </span>

          <h3>
            Sign in to create or join a team
          </h3>

          <button
            type="button"
            class="pn8e-team-primary"
            data-pn8e-team-signin
          >
            Sign in
          </button>

        </div>
      `;

      return;

    }


    try {

      const state =
        await rpc(
          'pn_event_my_team_state',
          {
            p_event_id:
              row.id
          }
        );


      if (
        state?.kind ===
        'invite'
      ) {

        panel.innerHTML = `

          <div class="pn8e-team-card">

            <span class="pn8e-team-kicker">
              TEAM INVITATION
            </span>

            <h3>
              ${escapeHTML(
                state.team_name
              )}
            </h3>

            <p>
              You've been invited to join this team.
            </p>

            <button
              type="button"
              class="pn8e-team-primary"
              data-pn8e-team-accept="${escapeHTML(
                state.team_id
              )}"
            >
              Accept invitation
            </button>

          </div>
        `;

        return;

      }


      if (
        state?.kind !==
        'team'
      ) {

        panel.innerHTML = `

          <div class="pn8e-team-card">

            <span class="pn8e-team-kicker">
              TEAM EVENT
            </span>

            <h3>
              Create your team
            </h3>

            <p>
              ${
                escapeHTML(
                  row.team_size_min ||
                  2
                )
              }
              –
              ${
                escapeHTML(
                  row.team_size_max ||
                  4
                )
              }
              members required.
            </p>

            <input
              type="text"
              class="pn8e-team-input"
              data-pn8e-team-name
              placeholder="Team name"
              maxlength="80"
            >

            <button
              type="button"
              class="pn8e-team-primary"
              data-pn8e-team-create="${escapeHTML(
                row.id
              )}"
            >
              Create Team
            </button>

          </div>
        `;

        return;

      }


      const registered =
        [
          'confirmed',
          'attended'
        ]
          .includes(
            state.registration_status
          );


      const feeText =
        state.fee_type ===
          'per_member'
            ? `${money(
                row.price,
                state.currency ||
                row.currency
              )} per member · ${money(
                state.amount,
                state.currency ||
                row.currency
              )} total`
            : `${money(
                state.amount,
                state.currency ||
                row.currency
              )} per team`;


      let captainControls =
        '';


      if (
        state.is_captain
        &&
        !registered
      ) {

        const canEdit =
          state.team_status !==
            'payment_pending';


        const invite =
          canEdit
            ? `
                <div class="pn8e-team-invite">

                  <input
                    type="email"
                    class="pn8e-team-input"
                    data-pn8e-team-email
                    placeholder="Member email"
                  >

                  <button
                    type="button"
                    data-pn8e-team-invite="${escapeHTML(
                      state.team_id
                    )}"
                  >
                    Invite
                  </button>

                </div>
              `
            : `
                <div class="pn8e-team-note">
                  Checkout is reserved. Complete payment or retry the checkout.
                </div>
              `;


        let checkout =
          '';


        if (
          state.can_checkout
        ) {

          checkout =
            state.is_paid
              ? `
                  <button
                    type="button"
                    class="pn8e-team-primary pn8e-team-pay"
                    data-pn8e-team-pay="${escapeHTML(
                      state.team_id
                    )}"
                    data-event-id="${escapeHTML(
                      row.id
                    )}"
                  >
                    Pay ${escapeHTML(
                      money(
                        state.amount,
                        state.currency ||
                        row.currency
                      )
                    )} & Register
                  </button>
                `
              : `
                  <button
                    type="button"
                    class="pn8e-team-primary"
                    data-pn8e-team-free="${escapeHTML(
                      state.team_id
                    )}"
                    data-event-id="${escapeHTML(
                      row.id
                    )}"
                  >
                    Complete Registration
                  </button>
                `;

        }
        else if (
          Number(
            state.pending_invites ||
            0
          ) > 0
        ) {

          checkout = `
            <div class="pn8e-team-note">
              Resolve ${escapeHTML(
                state.pending_invites
              )} pending invitation(s) before registration.
            </div>
          `;

        }
        else if (
          Number(
            state.accepted_members ||
            0
          )
          <
          Number(
            state.minimum_members ||
            2
          )
        ) {

          checkout = `
            <div class="pn8e-team-note">
              You need at least
              ${escapeHTML(
                state.minimum_members
              )}
              accepted members before registration.
            </div>
          `;

        }


        captainControls =
          invite
          +
          checkout;

      }


      panel.innerHTML = `

        <div class="pn8e-team-card">

          <div class="pn8e-team-head">

            <div>

              <span class="pn8e-team-kicker">
                ${
                  registered
                    ? 'TEAM REGISTERED'
                    : 'YOUR TEAM'
                }
              </span>

              <h3>
                ${escapeHTML(
                  state.team_name
                )}
              </h3>

            </div>

            <span class="pn8e-team-status">
              ${escapeHTML(
                state.team_status
              )}
            </span>

          </div>


          <div class="pn8e-team-summary">

            <div>
              <small>MEMBERS</small>
              <strong>
                ${escapeHTML(
                  state.accepted_members
                )}
                /
                ${escapeHTML(
                  state.maximum_members
                )}
              </strong>
            </div>

            <div>
              <small>FEE</small>
              <strong>
                ${escapeHTML(
                  feeText
                )}
              </strong>
            </div>

          </div>


          <div class="pn8e-team-members">
            ${pnTeamMembersHTML(
              state
            )}
          </div>


          ${
            registered
              ? `
                  <div class="pn8e-team-ticket">

                    <small>
                      REGISTRATION CONFIRMED
                    </small>

                    <strong>
                      ${escapeHTML(
                        state.ticket_code ||
                        'Ticket confirmed'
                      )}
                    </strong>

                  </div>
                `
              : ''
          }


          ${
            !state.is_captain
            &&
            !registered
              ? `
                  <div class="pn8e-team-note">
                    Your team captain will complete the registration and payment.
                  </div>
                `
              : ''
          }


          ${captainControls}

        </div>
      `;

    }
    catch (error) {

      panel.innerHTML = `
        <div class="pn8e-team-card">
          <strong>
            Team registration could not be loaded.
          </strong>

          <p>
            ${escapeHTML(
              error?.message ||
              'Please try again.'
            )}
          </p>
        </div>
      `;

    }

  }


  /*
   * Capture event actions BEFORE the original
   * free-registration listener.
   */
  root.addEventListener(
    'click',
    async event => {

      const target =
        event.target instanceof Element
          ? event.target
          : null;


      if (!target) {
        return;
      }


      const signin =
        target.closest(
          '[data-pn8e-team-signin]'
        );


      if (signin) {

        event.preventDefault();
        event.stopImmediatePropagation();

        window.location.href =
          '/pages/login';

        return;

      }


      const create =
        target.closest(
          '[data-pn8e-team-create]'
        );


      if (create) {

        event.preventDefault();
        event.stopImmediatePropagation();


        const modal =
          create.closest(
            '[data-pn8e-event-modal]'
          );


        const row =
          pnEventById(
            create.dataset
              .pn8eTeamCreate
          );


        const input =
          modal?.querySelector(
            '[data-pn8e-team-name]'
          );


        const name =
          input?.value
            ?.trim();


        if (!name) {

          window.alert(
            'Enter a team name.'
          );

          return;

        }


        create.disabled =
          true;


        try {

          await rpc(
            'pn_event_create_team',
            {
              p_event_id:
                row.id,

              p_team_name:
                name
            }
          );


          await hydrateEventTeamPanel(
            row,
            modal
          );

        }
        catch (error) {

          window.alert(
            error?.message ||
            'Could not create team.'
          );


          create.disabled =
            false;

        }


        return;

      }


      const accept =
        target.closest(
          '[data-pn8e-team-accept]'
        );


      if (accept) {

        event.preventDefault();
        event.stopImmediatePropagation();


        const modal =
          accept.closest(
            '[data-pn8e-event-modal]'
          );


        const panel =
          modal?.querySelector(
            '[data-pn8e-team-panel]'
          );


        const row =
          pnEventById(
            panel?.dataset
              .pn8eTeamPanel
          );


        accept.disabled =
          true;


        try {

          await rpc(
            'pn_event_accept_team_invite',
            {
              p_team_id:
                accept.dataset
                  .pn8eTeamAccept
            }
          );


          await hydrateEventTeamPanel(
            row,
            modal
          );

        }
        catch (error) {

          window.alert(
            error?.message ||
            'Could not accept invitation.'
          );


          accept.disabled =
            false;

        }


        return;

      }


      const invite =
        target.closest(
          '[data-pn8e-team-invite]'
        );


      if (invite) {

        event.preventDefault();
        event.stopImmediatePropagation();


        const modal =
          invite.closest(
            '[data-pn8e-event-modal]'
          );


        const panel =
          modal?.querySelector(
            '[data-pn8e-team-panel]'
          );


        const row =
          pnEventById(
            panel?.dataset
              .pn8eTeamPanel
          );


        const input =
          modal?.querySelector(
            '[data-pn8e-team-email]'
          );


        const email =
          input?.value
            ?.trim();


        if (!email) {

          window.alert(
            'Enter the member email.'
          );

          return;

        }


        invite.disabled =
          true;


        try {

          await rpc(
            'pn_event_invite_team_member',
            {
              p_team_id:
                invite.dataset
                  .pn8eTeamInvite,

              p_email:
                email
            }
          );


          await hydrateEventTeamPanel(
            row,
            modal
          );

        }
        catch (error) {

          window.alert(
            error?.message ||
            'Could not invite member.'
          );


          invite.disabled =
            false;

        }


        return;

      }


      const remove =
        target.closest(
          '[data-pn8e-team-remove]'
        );


      if (remove) {

        event.preventDefault();
        event.stopImmediatePropagation();


        const modal =
          remove.closest(
            '[data-pn8e-event-modal]'
          );


        const panel =
          modal?.querySelector(
            '[data-pn8e-team-panel]'
          );


        const row =
          pnEventById(
            panel?.dataset
              .pn8eTeamPanel
          );


        remove.disabled =
          true;


        try {

          await rpc(
            'pn_event_remove_team_member',
            {
              p_team_id:
                remove.dataset
                  .teamId,

              p_member_id:
                remove.dataset
                  .pn8eTeamRemove
            }
          );


          await hydrateEventTeamPanel(
            row,
            modal
          );

        }
        catch (error) {

          window.alert(
            error?.message ||
            'Could not remove member.'
          );


          remove.disabled =
            false;

        }


        return;

      }


      const freeTeam =
        target.closest(
          '[data-pn8e-team-free]'
        );


      if (freeTeam) {

        event.preventDefault();
        event.stopImmediatePropagation();


        const modal =
          freeTeam.closest(
            '[data-pn8e-event-modal]'
          );


        const row =
          pnEventById(
            freeTeam.dataset
              .eventId
          );


        freeTeam.disabled =
          true;

        freeTeam.textContent =
          'Registering…';


        try {

          await rpc(
            'pn_event_register_team_free',
            {
              p_team_id:
                freeTeam.dataset
                  .pn8eTeamFree
            }
          );


          await hydrateEventTeamPanel(
            row,
            modal
          );

        }
        catch (error) {

          window.alert(
            error?.message ||
            'Could not register team.'
          );


          freeTeam.disabled =
            false;

          freeTeam.textContent =
            'Complete Registration';

        }


        return;

      }


      const teamPay =
        target.closest(
          '[data-pn8e-team-pay]'
        );


      if (teamPay) {

        event.preventDefault();
        event.stopImmediatePropagation();


        const modal =
          teamPay.closest(
            '[data-pn8e-event-modal]'
          );


        const row =
          pnEventById(
            teamPay.dataset
              .eventId
          );


        const original =
          teamPay.textContent;


        teamPay.disabled =
          true;

        teamPay.textContent =
          'Preparing payment…';


        try {

          const reservation =
            await rpc(
              'pn_pay_reserve_event_team',
              {
                p_team_id:
                  teamPay.dataset
                    .pn8eTeamPay
              }
            );


          await pnRunEventRazorpay(
            reservation,
            row,
            teamPay
          );


          await hydrateEventTeamPanel(
            row,
            modal
          );

        }
        catch (error) {

          window.alert(
            error?.message ||
            'Could not complete team payment.'
          );


          await hydrateEventTeamPanel(
            row,
            modal
          );

        }
        finally {

          if (
            teamPay.isConnected
          ) {

            teamPay.disabled =
              false;

            teamPay.textContent =
              original;

          }

        }


        return;

      }


      /*
       * EXISTING REGISTER BUTTON
       *
       * Individual + free:
       *   let the old handler continue.
       *
       * Individual + paid:
       *   Razorpay.
       *
       * Team:
       *   open/manage team modal instead.
       */
      const register =
        target.closest(
          '[data-pn8e-register]'
        );


      if (!register) {
        return;
      }


      const row =
        pnEventById(
          register.dataset
            .pn8eRegister
        );


      if (!row) {
        return;
      }


      if (
        row.participation_type ===
        'team'
      ) {

        event.preventDefault();
        event.stopImmediatePropagation();


        if (
          !await requireSession()
        ) {
          return;
        }


        openEventModal(
          row
        );


        return;

      }


      if (
        row.is_paid
        &&
        Number(
          row.price ||
          0
        ) > 0
      ) {

        event.preventDefault();
        event.stopImmediatePropagation();


        if (
          !await requireSession()
        ) {
          return;
        }


        await pnStartIndividualEventCheckout(
          row,
          register
        );

      }

    },
    true
  );


  /* =========================================================
     PN_EVENT_DETAIL_OPEN_V1
     Open a dynamic event detail view from any live event card.
  ========================================================= */

  function eventDetailURL(
    row
  ) {

    const identifier =
      row?.slug ||
      row?.id;


    if (!identifier) {
      return '';
    }


    return (
      '/pages/events?event='
      +
      encodeURIComponent(
        identifier
      )
    );

  }


  root.addEventListener(
    'click',
    event => {

      /*
       * Never hijack real interactive controls.
       */
      if (
        event.target.closest(
          [
            '[data-pn8e-register]',
            '[data-pn8e-cancel]',
            '[data-pn8e-save]',
            'button',
            'a',
            'input',
            'select',
            'textarea'
          ].join(',')
        )
      ) {
        return;
      }


      const card =
        event.target.closest(
          '[data-pn8e-event]'
        );


      if (
        !card ||
        !root.contains(card)
      ) {
        return;
      }


      const eventId =
        card.dataset
          .pn8eEvent;


      const row =
        events.find(
          item =>
            String(item.id) ===
            String(eventId)
        );


      const url =
        eventDetailURL(
          row
        );


      if (!url) {
        return;
      }


      openEventModal(
        row
      );

    }
  );




  /* =========================================================
     PN_EVENT_DETAIL_RENDER_V1
     Same /pages/events page becomes a dynamic event detail
     screen whenever ?event=<slug-or-id> is present.
  ========================================================= */

  function requestedEventKey() {

    return (
      new URLSearchParams(
        window.location.search
      )
        .get(
          'event'
        )
        ?.trim()
      ||
      ''
    );

  }


  function findRequestedEvent() {

    const key =
      requestedEventKey();


    if (!key) {
      return null;
    }


    return (
      events.find(
        row =>
          String(
            row.slug ||
            ''
          ) === key
          ||
          String(
            row.id ||
            ''
          ) === key
      )
      ||
      null
    );

  }


  function eventActionHTML(
    row
  ) {

    /*
     * Reuse the EXISTING card action logic instead of
     * duplicating registration/payment rules.
     */
    const holder =
      document.createElement(
        'div'
      );


    holder.innerHTML =
      card(
        row
      );


    const action =
      holder.querySelector(
        '.pn8e-actions'
      );


    return (
      action?.innerHTML ||
      ''
    );

  }


  function eventSaveHTML(
    row
  ) {

    const holder =
      document.createElement(
        'div'
      );


    holder.innerHTML =
      card(
        row
      );


    const save =
      holder.querySelector(
        '[data-pn8e-save]'
      );


    return (
      save?.outerHTML ||
      ''
    );

  }


  function renderEventDetailFromURL() {

    const key =
      requestedEventKey();


    /*
     * Normal /pages/events listing.
     */
    if (!key) {
      return false;
    }


    const row =
      findRequestedEvent();


    if (!row) {

      grid.innerHTML = `
        <div class="pn8e-detail-state">

          <span>◇</span>

          <h2>
            Event not found
          </h2>

          <p>
            This event may no longer be published.
          </p>

          <a
            href="/pages/events"
            class="pn8e-detail-back"
          >
            ← Back to all events
          </a>

        </div>
      `;

      return true;

    }


    const eventDate =
      new Date(
        row.starts_at
      );


    const eventTiming = {

      date:
        Number.isNaN(
          eventDate.getTime()
        )
          ? 'Date TBA'
          : eventDate.toLocaleDateString(
              'en-IN',
              {
                day:'numeric',
                month:'short',
                year:'numeric'
              }
            ),

      time:
        Number.isNaN(
          eventDate.getTime()
        )
          ? 'Time TBA'
          : eventDate.toLocaleTimeString(
              'en-IN',
              {
                hour:'numeric',
                minute:'2-digit'
              }
            )

    };


    const image =
      row.cover_image_url
        ? `
            <img
              src="${escapeHTML(
                row.cover_image_url
              )}"
              alt="${escapeHTML(
                row.title ||
                'PeerNest Event'
              )}"
            >
          `
        : `
            <div class="pn8e-detail-placeholder">

              <span>✦</span>

              <small>
                PEERNEST EVENT
              </small>

            </div>
          `;


    const spots =
      row.spots_left === null
      ||
      row.spots_left === undefined
        ? ''
        : (
            Number(
              row.spots_left
            ) > 0
              ? `${Number(
                  row.spots_left
                )} spots left`
              : 'Event full'
          );


    const actionHTML =
      eventActionHTML(
        row
      );


    const saveHTML =
      eventSaveHTML(
        row
      );


    grid.innerHTML = `

      <article
        class="pn8e-detail"
        data-pn8e-detail="${escapeHTML(
          row.id
        )}"
      >

        <div class="pn8e-detail__top">

          <a
            href="/pages/events"
            class="pn8e-detail-back"
          >
            ← All events
          </a>

          ${
            saveHTML
              ? `
                  <div class="pn8e-detail__save">
                    ${saveHTML}
                  </div>
                `
              : ''
          }

        </div>


        <div class="pn8e-detail__layout">

          <div class="pn8e-detail__media">
            ${image}
          </div>


          <div class="pn8e-detail__content">

            <div class="pn8e-detail__eyebrow">

              <span>
                ${escapeHTML(
                  normal(
                    row.event_type ||
                    'Event'
                  )
                )}
              </span>

              ${
                row.mode
                  ? `
                      <span>
                        ${escapeHTML(
                          normal(
                            row.mode
                          )
                        )}
                      </span>
                    `
                  : ''
              }

            </div>


            <h1>
              ${escapeHTML(
                row.title ||
                'PeerNest Event'
              )}
            </h1>


            <div class="pn8e-detail__quick">

              <div>
                <small>
                  DATE
                </small>

                <strong>
                  ${escapeHTML(
                    eventTiming.date
                  )}
                </strong>
              </div>


              <div>
                <small>
                  TIME
                </small>

                <strong>
                  ${escapeHTML(
                    eventTiming.time
                  )}
                </strong>
              </div>


              <div>
                <small>
                  LOCATION
                </small>

                <strong>
                  ${escapeHTML(
                    locationText(
                      row
                    )
                  )}
                </strong>
              </div>


              <div>
                <small>
                  PRICE
                </small>

                <strong>
                  ${escapeHTML(
                    money(
                      row.price,
                      row.currency
                    )
                  )}
                </strong>
              </div>

            </div>


            ${
              spots
                ? `
                    <div class="pn8e-detail__spots">
                      ${escapeHTML(
                        spots
                      )}
                    </div>
                  `
                : ''
            }


            ${
              row.description
                ? `
                    <div class="pn8e-detail__description">

                      <h3>
                        About this event
                      </h3>

                      <p>
                        ${escapeHTML(
                          row.description
                        )}
                      </p>

                    </div>
                  `
                : ''
            }


            ${
              actionHTML
                ? `
                    <div class="pn8e-detail__actions pn8e-actions">
                      ${actionHTML}
                    </div>
                  `
                : ''
            }

          </div>

        </div>

      </article>
    `;


    return true;

  }


  async function init() {

    bindFilters();

    await load();

  }


  if (window.PeerNestDB) {

    init();

  }
  else {

    document.addEventListener(
      'peernest:supabase-ready',
      init,
      {
        once:true
      }
    );

  }

})();

/* PN FULL EVENT CARD CLICK START */

(() => {

  if (window.__pnFullEventCardClick) {
    return;
  }

  window.__pnFullEventCardClick = true;


  function pnCardClickIsInteractive(target) {

    return !!target.closest(
      'a, button, input, select, textarea, label, summary, details, [role="button"], [role="link"]'
    );

  }


  function eventDetailsControl(card) {

    /*
      First use any explicit detail/open control
      added by the live Events system.
    */

    const explicit =
      card.querySelector(
        [
          '[data-pn8e-details]',
          '[data-pn8e-view]',
          '[data-pn8e-open]',
          '[data-pne-view-event]'
        ].join(',')
      );

    if (explicit) {
      return explicit;
    }


    /*
      Then locate the existing "View event" /
      "Details" control by its visible copy.
    */

    return (
      [
        ...card.querySelectorAll(
          'a[href], button'
        )
      ].find(control => {

        const text =
          (control.textContent || '')
            .trim()
            .toLowerCase();

        return (
          text.includes('view event') ||
          text.includes('event details') ||
          text.includes('view details') ||
          text.includes('learn more')
        );

      }) || null
    );

  }


  document.addEventListener(
    'click',
    event => {

      const target = event.target;

      if (!(target instanceof Element)) {
        return;
      }


      const card =
        target.closest(
          '.pne-card, .pn8e-card'
        );

      if (!card) {
        return;
      }


      /*
        Save heart, registration buttons and any
        explicit CTA keep their current behaviour.
      */
      if (pnCardClickIsInteractive(target)) {
        return;
      }


      const control =
        eventDetailsControl(card);

      if (!control) {
        return;
      }


      control.click();

    }
  );


})();

/* PN FULL EVENT CARD CLICK END */

/* PNE COLLEGES STYLE BROWSE TOOLS JS START */

(() => {

  function initPneBrowseTools() {

    const page =
      document.querySelector(
        '[data-pne-page]'
      );

    if (!page) {
      return;
    }


    const search =
      page.querySelector(
        '[data-pne-list-search]'
      );

    const primarySearch =
      page.querySelector(
        '[data-pne-search]'
      );

    const primarySearchButton =
      page.querySelector(
        '[data-pne-search-button]'
      );

    const toggle =
      page.querySelector(
        '[data-pne-filter-toggle]'
      );

    const panel =
      page.querySelector(
        '.pne-filter-panel'
      );

    const badge =
      page.querySelector(
        '[data-pne-filter-count]'
      );

    const reset =
      page.querySelector(
        '[data-pne-reset]'
      );


    if (
      !search ||
      !toggle ||
      !panel
    ) {
      return;
    }


    /* ----------------------------------------
       CLOSED BY DEFAULT
    ---------------------------------------- */

    panel.classList.remove(
      'is-open'
    );

    toggle.classList.remove(
      'is-open'
    );

    toggle.setAttribute(
      'aria-expanded',
      'false'
    );


    /* ----------------------------------------
       FILTER COUNTER
       Sort is not counted as a filter.
    ---------------------------------------- */

    const countedFilters = [
      '[data-pne-category]',
      '[data-pne-mode]',
      '[data-pne-location]',
      '[data-pne-college]',
      '[data-pne-date]'
    ]
      .map(selector =>
        page.querySelector(selector)
      )
      .filter(Boolean);


    function syncFilterCount() {

      const active =
        countedFilters.filter(
          control =>
            String(
              control.value || ''
            ).trim() !== ''
        ).length;


      if (badge) {
        badge.textContent =
          String(active);
      }

    }


    /* ----------------------------------------
       OPEN / CLOSE DRAWER
    ---------------------------------------- */

    toggle.addEventListener(
      'click',
      () => {

        const open =
          panel.classList.toggle(
            'is-open'
          );

        toggle.classList.toggle(
          'is-open',
          open
        );

        toggle.setAttribute(
          'aria-expanded',
          open
            ? 'true'
            : 'false'
        );

      }
    );


    /* ----------------------------------------
       LOWER SEARCH MIRRORS EXISTING
       WORKING EVENT SEARCH
    ---------------------------------------- */

    if (primarySearch) {

      search.value =
        primarySearch.value || '';


      search.addEventListener(
        'input',
        () => {

          primarySearch.value =
            search.value;

          primarySearch.dispatchEvent(
            new Event(
              'input',
              {
                bubbles: true
              }
            )
          );

          primarySearch.dispatchEvent(
            new Event(
              'change',
              {
                bubbles: true
              }
            )
          );

        }
      );


      search.addEventListener(
        'keydown',
        event => {

          if (event.key !== 'Enter') {
            return;
          }

          event.preventDefault();

          if (primarySearchButton) {
            primarySearchButton.click();
          }

        }
      );


      primarySearch.addEventListener(
        'input',
        () => {

          if (
            search.value !==
            primarySearch.value
          ) {
            search.value =
              primarySearch.value;
          }

        }
      );

    }


    /* ----------------------------------------
       ACTIVE FILTER COUNTER
    ---------------------------------------- */

    countedFilters.forEach(
      control => {

        control.addEventListener(
          'change',
          syncFilterCount
        );

      }
    );


    /* ----------------------------------------
       RESET
    ---------------------------------------- */

    if (reset) {

      reset.addEventListener(
        'click',
        () => {

          window.setTimeout(
            () => {

              if (primarySearch) {
                search.value =
                  primarySearch.value || '';
              }

              syncFilterCount();

            },
            0
          );

        }
      );

    }


    syncFilterCount();

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initPneBrowseTools,
      {
        once: true
      }
    );

  }

  else {
    initPneBrowseTools();
  }

})();

/* PNE COLLEGES STYLE BROWSE TOOLS JS END */
